import React from 'react';
import { BetTypeRectangleTableBottom } from '../../../enums/tableNumbers';
import { uuid } from '../../../helpers/uuid';
import ChipOnTable from '../../chip/chip-on-table';
import { useTranslation } from '@pascal/pascal-core';

const numberEndings = ['st', 'nd', 'rd'];
const { Dozen_1, Dozen_2, Dozen_3, Numbers_1_18, Even, Red, Black, Odd, Numbers_19_36 } = BetTypeRectangleTableBottom;
const dozensTopColumns = [Dozen_1, Dozen_2, Dozen_3];
const dozensBottomColumns = [Numbers_1_18, Even, Red, Black, Odd, Numbers_19_36];

const dozensBottomComponents = {
  Dozens: (column, index) => (
    <p className='bt-cl-row-text' data={column}>
      {index + 1}
      <sup data={column}>{numberEndings[index]}</sup>12
    </p>
  ),
  Numbers_1_18: (column) => (
    <p className='bt-cl-text' data={column}>
      1 - 18
    </p>
  ),
  Even: (column, index, t) => (
    <p className='bt-cl-text' data={column}>
      {t('EVEN')}
    </p>
  ),
  Red: () => {},
  Black: () => {},
  Odd: (column, index, t) => (
    <p className='bt-cl-text' data={column}>
      {t('ODDD')}
    </p>
  ),
  Numbers_19_36: (column) => (
    <p className='bt-cl-text' data={column}>
      19 - 36
    </p>
  ),
};

export const RectangleTableBottom = ({ allChipsTypes, handleGetColumnChip }) => {
  const t = useTranslation();

  return (
    <div className='main-game-cont-table-bottom'>
      <div className='main-game-cont-table-b-item'>
        {dozensTopColumns.map((column, index) => {
          const columnChip = handleGetColumnChip(column);
          return (
            <div
              key={uuid()}
              className={`bt-cl-box ${columnChip?.hasOwnProperty(column) ? 'active' : ''}`}
              data={column}
            >
              <ChipOnTable
                type={column}
                columnChips={columnChip}
                child={() => dozensBottomComponents.Dozens(column, index)}
                allChipsTypes={allChipsTypes}
              />
            </div>
          );
        })}
      </div>
      <div className='main-game-cont-table-b-item'>
        {dozensBottomColumns.map((column, index) => {
          const columnChip = handleGetColumnChip(column);
          return (
            <div
              key={uuid()}
              className={`bt-cl-box ${(column === Red && 'red') || (column === Black && 'black')} ${
                (column !== Red || column !== Black) && columnChip?.hasOwnProperty(column) ? 'active' : ''
              }`}
              data={column}
            >
              <ChipOnTable
                type={column}
                columnChips={columnChip}
                child={() => dozensBottomComponents?.[column](column, index, t)}
                allChipsTypes={allChipsTypes}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
